import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9efcfaf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup__title" }, "Delete account", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "popup__description" }, " Are you sure you want to delete your account? ", -1))
const _hoisted_3 = { class: "popup-buttons" }
const _hoisted_4 = ["disabled"]

import PopupTemplate from "@/components/popups/PopupTemplate.vue";
import { useAppStore } from "@/stores/app";
import { ref, Ref } from "vue";
import MainLoader from "@/components/MainLoader.vue";
import { useUserStore } from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupDeleteAccount',
  setup(__props) {

const appStore = useAppStore();
const userStore = useUserStore();
const loading: Ref<boolean> = ref(false);

const close = (): void => appStore.closePopup();
const deleteAccount = async (): Promise<void> => {
  loading.value = true;
  await userStore.deleteAccount();
  loading.value = false;
  close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupTemplate, null, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btn btn-b btn-default",
          onClick: close
        }, "Cancel"),
        _createElementVNode("button", {
          class: "btn btn-b btn-default delete",
          onClick: deleteAccount,
          disabled: loading.value
        }, [
          _createTextVNode(" Delete "),
          (loading.value)
            ? (_openBlock(), _createBlock(MainLoader, { key: 0 }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4)
      ])
    ]),
    _: 1
  }))
}
}

})